<template>
  <div class="pricing-1 pt-125 pb-100 petit" id="main">
    <div class="container">
      <div v-if="validation == 0">
        <div class="row">
          <div class="col-md-12 mx-auto text-center">
            <i class="ni ni-fat-remove ni-3x" style="color: red"></i>
            <h2 class="title mb-3 mt-1">Votre règlement a échoué</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <br />
              Vous pouvez réitérer l'opération en cliquant sur le bouton
              ci-dessous.<br /><br />
              Si vous n'arrivez toujours pas à payer en ligne avec le système de
              CB, vous pouvez nous contacter pour avoir des possibilitées de
              paiements différentes.
            </div>
          </div>
        </div>
        <div class="txt">
          <br /><br /><br />
          <router-link to="/recouvrement">
            <base-button type="anhod2">Retourner à l'accueil</base-button>
          </router-link>
          &nbsp;
          <router-link to="/paiement">
            <base-button type="anhod1"
              >Retourner au Paiement</base-button
            > </router-link
          ><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
      </div>
      <div v-if="validation == 1">
        <div class="row">
          <div class="col-md-12 mx-auto text-center">
            <i class="ni ni-check-bold ni-3x" style="color: green"></i>
            <h2 class="title mb-3 mt-1">Votre règlement a été accepté</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <br />
              Nous vous remercions pour votre règlement !<br /><br />
              Si vous n'avez pas encore payé l'intégralité vous pouvez encore
              accéder à votre interface client.<br /><br />
              Si vous avez une question vous pouvez toujours nous contacter par
              téléphone sur la page Contact ou par Message.
              <br /><br />
            </div>
          </div>
        </div>
        <div class="txt">
          <br /><br /><br />
          <router-link to="/recouvrement">
            <base-button type="anhod2">Retourner à l'accueil</base-button>
          </router-link>
        </div>
      </div>
      <div v-if="validation == 2">
        <div class="row">
          <div class="col-md-12 mx-auto text-center">
            <i class="ni ni-fat-remove ni-3x" style="color: red"></i>
            <h2 class="title mb-3 mt-1">Vous avez annulé votre règlement</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <br />
              Vous pouvez réitérer l'opération en cliquant sur le bouton
              ci-dessous.<br /><br />
            </div>
          </div>
        </div>
        <div class="txt">
          <br /><br /><br />
          <router-link to="/recouvrement">
            <base-button type="anhod2">Retourner à l'accueil</base-button>
          </router-link>
          &nbsp;
          <router-link to="/paiement">
            <base-button type="anhod1"
              >Retourner au Paiement</base-button
            > </router-link
          ><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaiementCheck",
  data() {
    return {
      validation: this.$route.params.validation
    };
  }
};
</script>

<style scoped>
.petit {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
}
.txt {
  text-align: center;
}
</style>
